/**
 * @flow
 * @relayHash 108734e2aefb318827265c5dba3cd959
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateMapShareLinkInput = {
  savedAreaId?: ?string,
  indicators?: ?$ReadOnlyArray<?MapCardIndicatorInput>,
  zoom?: ?number,
  center?: ?PointInput,
  clientMutationId?: ?string,
};
export type MapCardIndicatorInput = {
  id?: ?string,
  alpha?: ?number,
  isVisible?: ?boolean,
  palette?: ?number,
  customPalette?: ?$ReadOnlyArray<?string>,
  position?: ?number,
};
export type PointInput = {
  lng?: ?number,
  lat?: ?number,
};
export type ShareMapPopupEmbedCodeMutationVariables = {|
  input: CreateMapShareLinkInput
|};
export type ShareMapPopupEmbedCodeMutationResponse = {|
  +createMapShareLink: ?{|
    +mapCardNode: ?{|
      +id: string
    |}
  |}
|};
export type ShareMapPopupEmbedCodeMutation = {|
  variables: ShareMapPopupEmbedCodeMutationVariables,
  response: ShareMapPopupEmbedCodeMutationResponse,
|};
*/


/*
mutation ShareMapPopupEmbedCodeMutation(
  $input: CreateMapShareLinkInput!
) {
  createMapShareLink(input: $input) {
    mapCardNode {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMapShareLinkInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createMapShareLink",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateMapShareLinkInput!"
      }
    ],
    "concreteType": "CreateMapShareLinkPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "mapCardNode",
        "storageKey": null,
        "args": null,
        "concreteType": "BoardCardUseNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ShareMapPopupEmbedCodeMutation",
  "id": null,
  "text": "mutation ShareMapPopupEmbedCodeMutation(\n  $input: CreateMapShareLinkInput!\n) {\n  createMapShareLink(input: $input) {\n    mapCardNode {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShareMapPopupEmbedCodeMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ShareMapPopupEmbedCodeMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3c0d2671c502599585500d8acec37e2b';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/CommonComponents/__generated__/ShareMapPopupEmbedCodeMutation.graphql.js